import { render } from "./NatStep2.vue?vue&type=template&id=4d5a0d7d&scoped=true"
import script from "./NatStep2.vue?vue&type=script&lang=js"
export * from "./NatStep2.vue?vue&type=script&lang=js"

import "../form.css?vue&type=style&index=0&id=4d5a0d7d&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5a0d7d"]])

export default __exports__